import { openNotification } from '@/helpers/mantine-notification-helper';
import { IconMinus } from '@/icons/IconMinus';
import { IconPlus } from '@/icons/IconPlus';
import { IProductDetails } from '@/interfaces/product';
import { Select } from '@mantine/core';
import Image from 'next/image';
import { Dispatch, SetStateAction } from 'react';

interface IImage {
  ProductId: string;
  Url: any;
  IsVideo: boolean;
  IsFeaturedImage: boolean;
  IsSizeGuide: boolean;
  DisplayOrder: number;
  AltAttribute: string;
  TitleAttribute: string;
}

const FloatingCart = ({
  product,
  addToCart,
  productSize,
  selectProductSize,
  setProductQuantity,
  productQuantity,
  selectedSize,
  setSelectedSize,
}: {
  product: IProductDetails;
  addToCart: (product: IProductDetails, shouldOpenCart?: boolean, shouldOpenNotification?: boolean) => void;
  productSize: number;
  selectProductSize: (size: number) => void;
  productQuantity: number;
  setProductQuantity: Dispatch<SetStateAction<number>>;
  selectedSize: string;
  setSelectedSize: (e: string) => void;
}) => {
  const data: any[] = [];
  const selectedColor = product.AvailableColors?.find((x) => x.OwnColor)?.ColorName;

  product?.Variations?.forEach((variation) => {
    if (variation?.StockQuantity > 0) {
      const labelValue = variation?.ProductAttributeValue + ' / ' + selectedColor + ' / Tk ' + product?.ProductPrice?.Price;
      data.push({
        label: labelValue,
        value: labelValue,
      });
    }
  });
  return (
    <div className="fixed inset-x-0 bottom-0 z-20 ml-auto flex items-center justify-center  bg-white px-10 text-base font-normal  text-white drop-shadow-[0_35px_30px_rgba(0,0,0,0.5)] max-md:flex-wrap max-md:gap-y-3 max-md:py-6 md:h-24">
      <div className="mx-2 my-1 hidden md:block">
        {product?.ProductImageList?.map(
          (img: IImage) =>
            img.IsFeaturedImage === true && (
              <Image key={img.ProductId} src={img.Url} alt={img.AltAttribute} height={20} width={40} quality={100} unoptimized={true}></Image>
            ),
        )}
      </div>
      <span className=" hidden truncate whitespace-nowrap px-3 text-xl text-black md:block">{product?.Name}</span>
      {!product?.IsGiftVoucher && (
        <div className="w-full md:w-1/6">
          <Select
            placeholder={`${productSize !== -1 ? selectedSize + ' / ' + selectedColor + ' / Tk ' + product?.ProductPrice?.Price : 'Select Size'}`}
            data={data}
            maxDropdownHeight={800}
            onChange={(e) => {
              if (e) {
                const temp = e?.split(' ');
                setSelectedSize(e);
                selectProductSize(temp?.[0] as unknown as number);
              }
            }}
            sx={{
              '.mantine-Select-input': {
                border: '1px solid rgb(164 164 164) !important',
                cursor: 'pointer',
                padding: '0px 30px 0px 13px !important',
                fontSize: '14px',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                textAlign: 'center',
                height: '34px !important',
              },
              '.mantine-Select-item': {
                display: 'block !important',
                padding: '5px, 0 !important',
                fontSize: '14px',
              },
              '.mantine-Select-item:hover': {
                color: '#5572ad',
                background: 'none',
              },

              '.mantine-Select-rightSection': { display: 'none' },
              '.mantine-Select-wrapper': { background: 'none' },
            }}
          ></Select>
        </div>
      )}

      <div className="flex w-1/2 min-w-max items-center md:w-auto">
        <span className="mx-1 hidden text-gray-500 md:block lg:mx-2">Qty :</span>
        <span className="duration-30 relative mr-1.5 flex h-12 w-full cursor-pointer items-center justify-center overflow-hidden rounded-[5px] border border-gray-400 text-xl  transition-all md:w-36 ">
          <button
            onClick={() => {
              if (productQuantity > 1 && productSize !== -1) {
                setProductQuantity(productQuantity - 1);
              }
            }}
            className="active:scale-100"
          >
            <IconMinus className={`${productQuantity > 1 && productSize !== -1 ? ' text-black' : 'text-gray-400'} w-3`} />
          </button>
          <span className="text-xl text-black"> {productQuantity}</span>
          <button
            onClick={() => {
              if (
                productSize !== -1 &&
                productQuantity < (product.Variations?.find((x) => +x.ProductAttributeValue === +productSize)?.StockQuantity || 0)
              ) {
                setProductQuantity(productQuantity + 1);
              } else if (productSize === -1) {
                openNotification('danger', 'Error', 'Please select size.');
              } else if (productQuantity == product.Variations?.find((x) => +x.ProductAttributeValue === +productSize)?.StockQuantity) {
                openNotification('danger', 'Error', 'Product quantity exceeded stock on hand');
              }
            }}
            className="active:scale-100"
          >
            <IconPlus
              className={`${
                productSize !== -1 &&
                productQuantity < (product.Variations?.find((x) => +x.ProductAttributeValue === +productSize)?.StockQuantity || 0)
                  ? ' text-black'
                  : 'text-gray-400'
              } w-3`}
            />
          </button>
        </span>
      </div>
      <div className="w-1/2 pl-1.5 md:w-auto">
        <button
          className="flex h-12 w-full items-center justify-center bg-black"
          onClick={() => {
            if (productSize != -1) {
              addToCart(product, false, true);
            } else {
              openNotification('danger', 'Cart', 'Please select a size first.');
            }
          }}
        >
          Add to Cart
        </button>
      </div>
    </div>
  );
};

export default FloatingCart;
